import { initPage } from '../main';
import indexPage from '../views/index';
initPage(indexPage);
